import React from 'react'
import cx from 'classnames'
import { Text } from 'components/dataDisplay'

import s from './ExclusiveLabel.scss'


type ExclusiveLabelProps = {
  labelText: string | Intl.Message
}

const ExclusiveLabel: React.FC<ExclusiveLabelProps> = ({ labelText }) => {
  return (
    <span className={cx(s.label, 'px-12 py-4 ml-16 text-white')}>
      <Text message={labelText} style="eye3" />
    </span>
  )
}

export default ExclusiveLabel
